import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface SentSubscriberListPageProps extends NSARouterMakerResult, NotificationSenderProps { }

function SentSubscriberListPage(props: SentSubscriberListPageProps)
{
    return (
        <NotificationSenderLayout {...props}
            pages={{
                entity: NotificationSenderEntity.SentSubscriber(props),
                list: {
                    ui: {}
                }
            }}
        >
            <></>
        </NotificationSenderLayout>
    );
}

export default SentSubscriberListPage;